import colorSharp from "../assets/img/color-sharp.png";
import "./Certifications.css";

const certifications = [
  {
    name: "Microsoft Azure Fundamentals",
    code: "AZ-900",
    issuer: "Microsoft",
    date: "Sep 2026", // Update with your actual date
    credentialId: "3E14CA217AFD304C", // Add your credential ID if you have one
    verifyUrl: "https://learn.microsoft.com/api/credentials/share/en-us/KaveeshaDhanasekara/3E14CA217AFD304C?sharingId=3C747FBCEB2C4D1D", // Add your verification URL if you have one
    badge:
      "https://learn.microsoft.com/media/learn/certification/badges/microsoft-certified-fundamentals-badge.svg",
  },
  // Add more certifications here as you earn them, e.g.:
  // {
  //   name: "AWS Cloud Practitioner",
  //   code: "CLF-C02",
  //   issuer: "Amazon Web Services",
  //   date: "2026",
  //   credentialId: "",
  //   verifyUrl: "",
  //   badge: "https://...",
  // },
];

export const Certifications = () => {
  return (
    <section className="certifications" id="certifications">
      <div className="container">
        <div className="cert-shell">
          <div className="cert-heading">
            <span className="cert-kicker">Verified Credentials</span>
            <h2>Certifications &amp; Credentials</h2>
            <p>
              Industry-recognized certifications that validate my cloud
              computing, DevOps, and software engineering expertise.
            </p>
          </div>

          <div className="cert-grid">
            {certifications.map((cert, index) => (
              <div className="cert-card" key={index}>
                {/* Badge */}
                <div className="cert-badge">
                  {cert.badge ? (
                    <img src={cert.badge} alt={`${cert.name} badge`} />
                  ) : (
                    <span className="cert-badge-fallback">{cert.code}</span>
                  )}
                </div>

                {/* Info */}
                <div className="cert-info">
                  <span className="cert-name">{cert.name}</span>
                  <span className="cert-issuer">
                    {cert.issuer}
                    {cert.code && ` · ${cert.code}`}
                  </span>

                  <div className="cert-meta">
                    {cert.date && (
                      <span className="cert-date">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 16 16"
                          fill="currentColor"
                        >
                          <path d="M5.75 0a.75.75 0 0 1 .75.75V2h3V.75a.75.75 0 0 1 1.5 0V2H12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V.75A.75.75 0 0 1 5.75 0ZM3.5 7v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V7h-9Z" />
                        </svg>
                        Issued {cert.date}
                      </span>
                    )}
                    {cert.credentialId && (
                      <span className="cert-id">
                        ID: {cert.credentialId}
                      </span>
                    )}
                  </div>

                  {cert.verifyUrl && (
                    <a
                      href={cert.verifyUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="cert-verify"
                    >
                      Verify
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                      >
                        <path d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                        <path d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                      </svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  );
};

